import stepModule1 from "../Step/stepDefaultModuleProp";
import stepModule2 from "../Step/stepDefaultModuleProp";

const hiringProcessModule = {
  // other module props
  id: "2d702500-6274-430c-9dba-fb249a784819",
  config: {
    general: {
      template: {
        label: "Horizontal", // or "Vertical"
        component: "HiringProcessHorizontal", // or "HiringProcessVertical"
      },
      paddings: {
        top: true,
        bottom: true,
      },
      media: {
        url: "https://tc-media.job-shop.com/content-modules/cover/header/cover-header.jpg",
        mediaType: "image",
      },
      showMedia: false,
      moduleBackgroundColor: {
        label: "Color 1",
        value: "#ffffe",
      },
      stepBackgroundColor: {
        label: "Color 2",
        value: "#F2F1F1",
      },
      textAlign: {
        label: "Left", // or Center
        value: "left", // or center
      },
      corners: {
        label: "Round", // or Square
        value: "round", // or square
      },
      showProgressionLine: true,
      showStepCounter: true,
      showHeader: true,
    },
  },
  modules: [stepModule1, stepModule2],
};

export default hiringProcessModule;
